module.exports = __webpack_public_path__ + "static/media/navbar_logo.e7e8e7d4.svg";